export default "__VITE_ASSET__D60o4cJn__"